export enum PublicDutiesOption {
    POLITICAL = '1',
    SENIOR_JUDGES = '2',
    GOVERNMENT_INTERNATIONAL = '3',
    AMBASSADORS = '4',
    OTHERS = '5',
}
